import { combineReducers } from 'redux';
import { getReducers } from 'src/config';
import * as reducers from '../redux/reducers';

export const reducer = combineReducers<any>({ ...reducers, ...getReducers() });
